"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButtonRow = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const styled_1 = __importDefault(require("../../styles/styled"));
const theme_1 = __importDefault(require("../../styles/theme"));
const IconButtonRow = ({ activeItemIndex, children, }) => {
    return ((0, jsx_runtime_1.jsxs)(IconButtonRowWrapper, { children: [(0, jsx_runtime_1.jsx)(AnimatedActiveIconBackground, { activeItemIndex: activeItemIndex }), children] }));
};
exports.IconButtonRow = IconButtonRow;
const IconButtonRowWrapper = styled_1.default.div(({ activeItemIndex }) => ({
    display: 'inline-flex',
    background: !activeItemIndex ? 'rgba(255, 255, 255, 0.5)' : theme_1.default.colors.white,
    padding: '6px',
    borderRadius: '26px',
    '> :not(:first-of-type)': {
        marginLeft: theme_1.default.spacing.m,
    },
    '> *': {
        zIndex: 2,
    },
}));
const AnimatedActiveIconBackground = styled_1.default.span(({ activeItemIndex }) => ({
    position: 'absolute',
    transform: `translateX(${activeItemIndex * 56}px)`,
    transition: `transform 200ms cubic-bezier(0.25,-0.20, 0.40, 1.25)`,
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: `${activeItemIndex === undefined ? theme_1.default.colors.transparent : theme_1.default.colors.azure}`,
    zIndex: 1,
}));
//# sourceMappingURL=icon_button_row.js.map